import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AddOns, ItemByMenu, MenuItem, StoreMenu } from './menuSliceTypes';

export interface CompleteMenuState {
  compeleteMenu: StoreMenu[];
  filterAllergens: any;
  filterTags: any;
  menuList: MenuItem[];
  itemByMenu: ItemByMenu;
  itemAddOns: AddOns;
  menuVersion: string;
  menuName: string | null;
}

const initialState: CompleteMenuState = {
  compeleteMenu: [],
  filterAllergens: {},
  filterTags: {},
  menuList: [],
  itemByMenu: {},
  itemAddOns: {},
  menuVersion: '',
  menuName: null,
};

export const menuMetadataSlice = createSlice({
  name: 'menuMetadata',
  initialState,
  reducers: {
    setMenuMetaData: (state, action: PayloadAction<any>) => {
      state.menuName = action.payload.menuName;
      state.compeleteMenu = action.payload.compeleteMenu;
      state.menuVersion = action.payload.menuVersion;
    },
    setFilterAllergensAndTags: (state, action: PayloadAction<any>) => {
      state.filterAllergens = action.payload.filterAllergens;
      state.filterTags = action.payload.filterTags;
    },

    setMenuList: (state, action: PayloadAction<any>) => {
      state.menuList = action.payload.menuList;
    },
    setItemByMenu: (state, action: PayloadAction<any>) => {
      state.itemByMenu = action.payload;
    },
    setItemAddOns: (state, action: PayloadAction<any>) => {
      state.itemAddOns = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMenuMetaData, setFilterAllergensAndTags, setMenuList, setItemByMenu, setItemAddOns } =
  menuMetadataSlice.actions;

export default menuMetadataSlice.reducer;
